import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './PlayerCard.module.scss';
import PlaceholderJugador from 'containers/Mundial2026/assets/placeholders/Jugador.png';

const MONTHS_ES = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sep',
  'Oct',
  'Nov',
  'Dic',
];

const formatMatchDate = dateStr => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-');
  const monthIdx = parseInt(month, 10) - 1;
  if (Number.isNaN(monthIdx) || !MONTHS_ES[monthIdx]) return '';
  return `${parseInt(day, 10)} ${MONTHS_ES[monthIdx]} ${year}`;
};

const ArrowDown = ({ assets }) => (
  <img
    src={assets?.eventodeportivo_icono_sale}
    alt=""
    width="10"
    height="12"
  />
);

const ArrowUp = ({ assets }) => (
  <img
    src={assets?.eventodeportivo_icono_entra}
    alt=""
    width="10"
    height="12"
  />
);

const PlayerCard = ({
  name,
  displayInfo,
  number,
  image,
  movements,
  matchDate,
  primaryColor,
}) => {
  const assets = useSelector(state => state.asset);

  const subOut = movements.find(m => m.type === 'SUBSTITUTION_OUT');
  const subIn = movements.find(m => m.type === 'SUBSTITUTION_IN');
  const hasFooter = Boolean(subOut || subIn);
  const formattedDate = formatMatchDate(matchDate);

  const hasNumber = number !== null && number !== undefined;

  return (
    <div className={styles['player-card']}>
      <div
        className={`${styles['player-card__body']} ${
          styles[!hasFooter ? 'without-footer' : '']
        }`}
      >
        <div className={styles['player-card__avatar']}>
          <img
            src={image || PlaceholderJugador}
            alt={name}
            className={styles['player-card__avatar-image']}
            onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = PlaceholderJugador; }}
          />
        </div>

        <div className={styles['player-card__avatar-line']} />

        <div className={styles['player-card__info']}>
          <div className={styles['player-card__identity']}>
            <p className={styles['player-card__name']}>{name}</p>
            {displayInfo && (
              <p className={styles['player-card__details']}>{displayInfo}</p>
            )}
          </div>
          {hasNumber && (
            <p className={styles['player-card__number']}>{`# ${number}`}</p>
          )}
        </div>
      </div>

      {hasFooter && (
        <>
          <div className={styles['player-card__divider']} />
          <div className={styles['player-card__footer']}>
            {subOut && (
              <div className={styles['player-card__sub']}>
                <span
                  className={`${styles['player-card__sub-icon']} ${
                    styles['player-card__sub-icon--out']
                  }`}
                >
                  <ArrowDown assets={assets} />
                </span>
                <span className={styles['player-card__sub-date']}>
                  {formattedDate}
                </span>
              </div>
            )}
            {subIn && (
              <div className={styles['player-card__sub']}>
                <span
                  className={`${styles['player-card__sub-icon']} ${
                    styles['player-card__sub-icon--in']
                  }`}
                >
                  <ArrowUp assets={assets} />
                </span>
                <span className={styles['player-card__sub-date']}>
                  {formattedDate}
                </span>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
};

PlayerCard.propTypes = {
  name: PropTypes.string.isRequired,
  displayInfo: PropTypes.string,
  number: PropTypes.number,
  image: PropTypes.string,
  movements: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      minute: PropTypes.number,
    }),
  ),
  matchDate: PropTypes.string,
  primaryColor: PropTypes.string,
};

PlayerCard.defaultProps = {
  displayInfo: null,
  number: null,
  image: null,
  movements: [],
  matchDate: null,
  primaryColor: null,
};

export default PlayerCard;
